import type { Mark } from '@atlaskit/react-ufo/common';

import type { LayoutShiftStats } from '@confluence/browser-metrics/entry-points/getLayoutShiftWithAttribution.ts';
import {
	pageLoadEventPlugin,
	customEventPlugin,
	ssrRegionPlugin,
	frontendNetworkPlugin,
} from '@confluence/browser-metrics/entry-points/plugins.ts';
import { getBuildInfo } from '@confluence/build-info';
import { fg } from '@confluence/feature-gating';

import { addCustomTimingsFromMarks } from './addCustomTimingsFromMarks.ts';

declare global {
	interface Window {
		__PO_ASSET_DISPLAYED__?: boolean;
	}
}

export const additionalPayloadData = (
	interaction: {
		id: string;
		end: number;
		start: number;
		ufoName: string;
		marks: Mark[];
	},
	otherMetadataFromSessionData: {
		cloudId: string;
		isShardPreProd: boolean;
		layoutShiftWithAttribution: Record<string, LayoutShiftStats>;
	},
) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		addCustomTimingsFromMarks(interaction.id, interaction.marks);
	}

	const buildInfoData = getBuildInfo();
	const buildInfo: any = {};

	if (buildInfoData) {
		Object.keys(buildInfoData).forEach((item) => {
			const newKey = `buildInfo:${item}`;
			buildInfo[newKey] = (buildInfoData as any)[item];
		});
	}

	const data = {
		...pageLoadEventPlugin({
			stop: interaction.end,
			start: interaction.start,
			key: interaction.ufoName,
		}),
		...customEventPlugin({
			stop: interaction.end,
			start: interaction.start,
			key: interaction.ufoName,
		}),
		...frontendNetworkPlugin({
			stop: interaction.end,
			start: interaction.start,
			key: interaction.ufoName,
		}),
		...ssrRegionPlugin(),
		...buildInfo,
		...otherMetadataFromSessionData,

		postOfficeAssetsDisplayed: window.__PO_ASSET_DISPLAYED__,
	};

	return {
		confluence: data,
	};
};
